// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-member__info-icon[data-v-baa75fa6]{margin:3px;font-size:21px}.wiki-table-member-read-receipts__add-icon[data-v-baa75fa6]{vertical-align:middle;color:#64bd63;font-size:27px;cursor:pointer}.wiki-table-member-read-receipts__counter[data-v-baa75fa6]{margin-left:10px;vertical-align:middle;font-size:18px;cursor:pointer}\n", ""]);
// Exports
module.exports = exports;
